/**
 * Versión tipada de los design tokens (fuente de verdad: tokens.css).
 * Úsala en JS solo cuando una variable CSS no sirva (p. ej. canvas, meta theme-color).
 */
export const accents = {
  navy: '#274987',
  blue: '#005cff',
  deepBlue: '#002691',
  sky: '#27aae1',
  mint: '#86cfb7',
  green: '#009750',
  lime: '#ebf437',
  yellow: '#fff200',
  tangerine: '#f18903',
  amber: '#fc7d0b',
  orange: '#ff4d00',
  coral: '#f15b5c',
  red: '#eb1a19',
  magenta: '#cf1c5f',
  purple: '#995395',
  lilac: '#d1b5d3',
  mauve: '#a28488',
  midnight: '#071827',
  black: '#231f20',
} as const;

export type AccentName = keyof typeof accents;

export const colors = {
  bg: '#ffffff',
  text: '#333333',
  textSecondary: '#666666',
  textTertiary: '#999999',
  line: '#cccccc',
  surface: '#f5f5f5',
  surfaceAlt: '#efefef',
  ink: '#000000',
  inkSoft: '#231f20',
} as const;

export const breakpoints = {
  tablet: 600,
  desktop: 970,
  wide: 1205,
} as const;

export const motion = {
  fastMs: 200,
  menuMs: 350,
  easing: 'ease-out',
} as const;

/** Acento por defecto de una campaña cuando el admin no elige uno. */
export const DEFAULT_ACCENT: AccentName = 'navy';
